module.exports = __webpack_public_path__ + "img/fcu.940dc383.jpg";